import React, { useEffect, useRef, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Box, Grid } from '@material-ui/core'
import { useApi, useStore } from '../../../../hooks/storeHook'
import { ProductFormItemRef } from '../../../widgets/productFormItem/productFormItem.types'
import { ProductFormItem } from '../../../widgets/productFormItem'
import { Button } from '../../../shared/ui/button'
import { useFormStyles } from '../../../shared/lib/hooks/useFormStyles'
import { useBoolState } from '../../../../hooks/commonHooks'
import { ProductNameMenu } from './productNameMenu'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import { mapFormValuesToFormData } from '../../../widgets/productForm/api/mapper'

export const ProductFormBatch = observer(() => {
  const [isSubmitting, setSubmitting, setFinished] = useBoolState()

  const { mpcardStore } = useStore()

  const [validationErrors, setValidationErrors] = useState<number[]>([])

  const formRefs = useRef<ProductFormItemRef[]>([])

  const formClasses = useFormStyles()

  const classes = useStyles()

  const containerRefs = useRef<(HTMLDivElement | null)[]>([])

  const [activeIndex, setActiveIndex] = useState(0)

  const api = useApi();

  const handleSaveAll = async () => {
    setSubmitting()
    const errors: number[] = []

    try {
      for (let index = 0; index < formRefs.current.length; index++) {
        const result = await formRefs.current[index]?.submit?.()

        if (!result?.data) {
          errors.push(index)
          continue
        }

        const data = result.data
        const selectedCard = mpcardStore.selectedProductCards[index]

        const formData = mapFormValuesToFormData(data, {
          deletedImageIds: [],
          productId: selectedCard?.id
        })

        if (!selectedCard?.id) {
          await api.createProductCard(formData)
        } else {
          await api.updateProductCard(formData)
        }
      }

      setValidationErrors(errors)
    } finally {
      setFinished()
    }
  }


  const onSelectForm = (index: number) => {
    containerRefs.current[index]?.scrollIntoView({behavior: 'smooth', block: 'start'})
    setActiveIndex(index)
  }

  const handleSaveSingle = async (index: number) => {
    setSubmitting()
    try {
      const result = await formRefs.current[index]?.submit?.()

      // Если форма не вернула результат или невалидна
      if (!result?.data) return

      const selectedCard = mpcardStore.selectedProductCards[index]

      const formData = mapFormValuesToFormData(result.data, {
        deletedImageIds: [],
        productId: selectedCard?.id
      })

      if (!selectedCard?.id) {
        await api.createProductCard(formData)
      } else {
        await api.updateProductCard(formData)
      }

      // удаляем карточку из интерфейса
      const updatedCards = mpcardStore.selectedProductCards.filter((_, i) => i !== index)
      mpcardStore.setSelectedProductCards(updatedCards)

    } catch (e) {
      console.error('Ошибка при перемещении карточки', mpcardStore.selectedProductCards[index]?.id, e)
    } finally {
      setFinished()
    }
  }

  useEffect(() => {
    const handleScroll = () => {
      const positions = containerRefs.current.map((ref, index) => {
        if (!ref) {
          return {index, top: Infinity}
        }
        const rect = ref.getBoundingClientRect()
        return {index, top: Math.abs(rect.top - 50)}
      })

      const closest = positions.reduce((a, b) => (a.top < b.top ? a : b))
      if (closest.index !== activeIndex) {
        setActiveIndex(closest.index)
      }
    }

    window.addEventListener('scroll', handleScroll, {passive: true})
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [activeIndex])

  return (
    <Box className={classes.wrapper}>
      <Box className={classes.contentContainer}>
        <ProductNameMenu onSelect={index => onSelectForm(index)} activeIndex={activeIndex} validationErrors={validationErrors} />

        <Grid className={classes.formContainer}>
          {mpcardStore.selectedProductCards.map((card, index) => (
            <div
              key={card.id}
              ref={el => {
                containerRefs.current[index] = el
              }}
            >
              <ProductFormItem
                data={card}
                ref={el => {
                  if (el) {
                    formRefs.current[index] = el
                  }
                }}
                handleButton={() => handleSaveSingle(index)}
                isSubmitting={isSubmitting}
                enableReadonlyMarkets={false}
                buttonText={"Сохранить"}
              />
            </div>
          ))}

          <Box mt={4}>
            <Button className={clsx(formClasses.button, classes.button)}
                    onClick={handleSaveAll}
                    disabled={isSubmitting}> Сохранить все</Button>
          </Box>
        </Grid>
      </Box>
    </Box>
  )
})

const useStyles = makeStyles(
  () => ({
    wrapper: {
      width: '100%',
      maxWidth: '100vw',
      boxSizing: 'border-box'
    },
    contentContainer: {
      display: 'flex',
    },
    formContainer: {
      flexGrow: 0,
      maxWidth: '100%',
      flexBasis: '100%',
      borderLeft: '1px solid #DFE4EB',
      padding: '26px 40px'
    },
    button: {
      margin: '0 !important'
    }
  }))
